import { useEffect } from "react";
import { useLocation, Routes, Route } from "react-router-dom";
import WOW from "wow.js";
import "./app.css"


import AnimatedCursor from "react-animated-cursor";
import ContactPage from "./My-Portfolio/Contact/ConatctSection"
import Home from "./My-Portfolio/Home/Home";
import EducationSection from "./My-Portfolio/Education/EducationSection";
import ExperienceSection from "./My-Portfolio/Experience/Experience";  
import ProjectSection from "./My-Portfolio/Projects/ProjectSection";

function App() {
  useEffect(() => {
    const wow = new WOW({
      boxClass: "wow",
      animateClass: "animated",
      offset: 0,
      mobile: false,
      live: true,
    });
    wow.init();
  }, []);

  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <>
      <AnimatedCursor
        innerSize={8}
        outerSize={32}
        color="248, 158, 82"
        outerAlpha={0.15}
        innerScale={0}
        outerScale={0}
        clickables={[
          "a",
          'input[type="text"]',
          'input[type="email"]',
          'input[type="number"]',
          'input[type="submit"]',
          'input[type="image"]',
          "label[for]",
          "select",
          "textarea",
          "button",
          ".link",
        ]}
      />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/projects" element={<ProjectSection />} />
        <Route path="/education" element={<EducationSection />} />
        <Route path="/experience" element={<ExperienceSection />} />
      </Routes>
    </>
  );
}



export default App;
